import { useMutation } from '@tanstack/react-query';
import { useAppConfigContext } from '@/context/AppConfig';
import type { SearchReportResponseData } from '@/reports/searchReport';
import { vehicleSearch, SearchParams } from '@/reports/vehicle/vehicleSearch';

export const useVehicleSearch = () => {
  const { logError } = useAppConfigContext();

  const generateVehicleReport = useMutation<
    SearchReportResponseData,
    Error,
    SearchParams
  >(vehicleSearch, {
    onError: (error) => {
      logError('Vehicle Search', error);
    },
  });

  const generateAndClaimVehicleReport = useMutation<
    SearchReportResponseData,
    Error,
    SearchParams
  >({
    mutationFn: (data) => vehicleSearch({ ...data, tag: 'self' }),
    onError: (error) => {
      logError('Vehicle Search', error);
    },
  });

  return {
    generateVehicleReport,
    generateAndClaimVehicleReport,
  };
};
